export default "__VITE_PUBLIC_ASSET__57071ac2__"